import { doCustomCalculation, getArgValues } from '@/modules/taxForms/_helper/doCustomCalculation'

const getSummary = (formValues, summaryMetaData) => {
  if (!formValues) {
    return {}
  }
  if (!summaryMetaData) {
    return {}
  }

  return Object.entries(summaryMetaData)
    .reduce((target, [prop, calcRef]) => {
      if (typeof calcRef === 'object') {
        if ('method' in calcRef) {
          const senderValue = calcRef.sender ? formValues[calcRef.sender] || 0 : 0
          const argValues = getArgValues(calcRef, formValues)
          const res = doCustomCalculation(calcRef, senderValue, argValues)
          target[prop] = res
        } else if ('value' in calcRef) {
          target[prop] = calcRef.value || 0
        }
      }
      return target
    }, {})
}

export default getSummary
